import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Shabab Ali', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hello, My name is',
  name: 'Shabab',
  subtitle: 'I am a full-stack web developer',
  cta: 'Know more',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne:
    'I am a full-stack web developer with 4 years of experience. I am developing web apps in Ruby on Rails, ReactJs, NodeJs.',
  paragraphTwo:
    "After completing my Bachelor's in Computer Science and Engineering, I started working in Wipro Technologies as a Software Engineer. In Wipro, I worked as a UI and Backend developer for the clients like Boeing and HSBC.",
  paragraphThree: 'In my free time, I love to read books and sit under night sky.',
  resume: 'https://drive.google.com/file/d/13V7FqiKHioVvq60QO0YUxmtjkouD5II8/view?usp=sharing', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'ABC Hospital - Book an appointment',
    info:
      'A react-redux single page responsive application, where user can see the details of doctors of ABC Hospital and book an appointment with the doctor.',
    info2:
      'Backend is developed in Ruby on Rails. User authentication is implemented using Json Web Token.',
    url: 'https://glacial-peak-60683.herokuapp.com/',
    repo: 'https://github.com/alishabab/appointment-booking-frontend', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project2.JPG',
    title: 'Pokemon Catalog',
    info:
      'Single Page Application developed in React/Redux. A user can see the pokemons from different catagories. Also user can see the statistics for each pokemon.',
    info2: 'An external api service (PokeAPI) is used to get pokemons data.',
    url: 'https://pokemon-catalog.herokuapp.com/',
    repo: 'https://github.com/alishabab/pokemon-catalog', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project3.JPG',
    title: 'Weather App',
    info:
      'Responsive weather app developed in JavaScript. A user needs to enter the city name to see the current weather condition. App has autocomplete input feature.',
    info2: 'It uses weather data from weatherAPI.com.',
    url: 'https://alishabab.github.io/js-weather-app/',
    repo: 'https://github.com/alishabab/js-weather-app', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project4.JPG',
    title: 'Social Mate - Mini Social Media Website',
    info:
      'Its a collaborative project. A mini social media website developed in Ruby on Rails. A user needs to signup/login to make a post or to add friends.',
    info2: 'Authentication via Twitter is also supported.',
    url: 'https://social-mate.herokuapp.com/',
    repo: 'https://github.com/alishabab/ror-social-scaffold', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'shababsaifi@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/shabab_ali',
    },
    {
      id: nanoid(),
      name: 'codepen',
      url: '',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/shababali',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/alishabab',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
